import { useFadeIn } from '@hooks/useFadeIn'
import { automatticCreed, taxjarWay } from '@content/valuesData'

export function ValuesSection() {
  const fade = useFadeIn()

  return (
    <section
      id="values"
      ref={fade.ref as React.RefObject<HTMLElement>}
      className={`modern-section ${fade.className}`}
    >
      <p className="modern-section__label">Values</p>
      <h2 className="modern-section__title">What I keep on the board</h2>

      <div className="modern-values__groups">
        <div className="modern-values__group">
          <h3 className="modern-values__heading">The Automattic Creed</h3>
          <blockquote className="modern-values__creed">
            {automatticCreed.map((line) => (
              <p key={line} className="modern-values__creed-line">
                {line}
              </p>
            ))}
          </blockquote>
          <a
            href="https://automattic.com/creed/"
            target="_blank"
            rel="noopener noreferrer"
            className="modern-values__attribution"
          >
            automattic.com/creed
          </a>
        </div>

        <div className="modern-values__group">
          <h3 className="modern-values__heading">The TaxJar Way</h3>
          <div className="modern-values__cards">
            {taxjarWay.map((value) => (
              <div key={value} className="modern-values__value-card">
                <span className="modern-values__value-text">{value}</span>
              </div>
            ))}
          </div>
          <p className="modern-values__attribution">
            Value cards from The TaxJar Way
          </p>
        </div>
      </div>
    </section>
  )
}
